import styled from 'styled-components';

interface StatBlockProps {
  label: string;
  value: string;
  detail?: string;
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.span`
  font-size: ${(p) => p.theme.step[0]}px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${(p) => p.theme.color.text[2]};
`;

const Value = styled.span`
  font-size: ${(p) => p.theme.step[7]}px;
  font-family: ${(p) => p.theme.font.mono};
  color: ${(p) => p.theme.color.text[0]};
  letter-spacing: -0.01em;
`;

const Detail = styled.span`
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[3]};
`;

export function StatBlock({ label, value, detail }: StatBlockProps) {
  return (
    <Block>
      <Label>{label}</Label>
      <Value>{value}</Value>
      {detail && <Detail>{detail}</Detail>}
    </Block>
  );
}
